import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'services/localization/useTranslation';
import SetPageTitle from 'components/Portals/SetPageTitle';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import Container from 'components/Container';
import UsersTable from './UsersTable';
import InviteUserDialog from './components/InviteUserDialog';
import * as NotificationActions from 'actions/NotificationActions';
import { useDispatch } from 'react-redux';

import { Routes, useTypedLocation } from 'routing';

const Users = () => {
	const { t } = useTranslation();
	const { state } = useTypedLocation();
	const dispatch = useDispatch();
	const [inviteDialogOpen, setInviteDialogOpen] = useState(false);

	const handleSuccess = () => {
		dispatch(
			NotificationActions.showNotification({
				message: `${t('users.invitationsSent', 'Invitations sent')}!`,
				variant: 'info',
			}),
		);
	};

	return (
		<>
			<SetPageTitle
				priority={2}
				title={t('shop.users', 'Users')}
				rightContent={
					<Button color="primary" variant="contained" onClick={() => setInviteDialogOpen(true)}>
						{t('users.newUser', 'New user')}
					</Button>
				}
			/>
			<SetPageNavAction
				priority={2}
				backAction={
					state?.from === Routes.HOME_VIEW
						? { to: Routes.HOME_VIEW, title: t('common:actions.home', 'Home') }
						: { to: Routes.ACCOUNT, title: t('account.pageTitle', 'Account') }
				}
				quickLinks={[]}
			/>
			<Container>
				<UsersTable />
			</Container>
			{inviteDialogOpen && (
				<InviteUserDialog
					open={inviteDialogOpen}
					onClose={() => setInviteDialogOpen(false)}
					onSuccess={handleSuccess}
				/>
			)}
		</>
	);
};

export default Users;
